import { add, isAfter, isBefore, parse } from '@sequencehq/utils/dates'
import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import { getNextBillingDateForSchedule } from 'lib/schedules/getNextBillingDateForSchedule'
import { getRecurrenceDateForPhases } from 'lib/schedules/getRecurrenceDateForPhases'
import { API_DATE_FORMAT } from '../editModalShortcuts.constants'

export const useNextScheduleBillingDate = (props: {
  billingScheduleId: string
}) => {
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId: props.billingScheduleId,
    select: data => {
      const phasesWithParsedDates = data.billingSchedule.phases.map(phase => ({
        ...phase,
        startDate: parse(phase.startDate, API_DATE_FORMAT, new Date()),
        endDate: phase.endDate
          ? parse(phase.endDate, API_DATE_FORMAT, new Date())
          : undefined
      }))

      const today = new Date()
      const phaseRecurrenceDates = getRecurrenceDateForPhases({
        recurrenceDayOfMonth: data.billingSchedule.recurrenceDayOfMonth,
        phases: phasesWithParsedDates
      })

      const currentPhaseIndex = phasesWithParsedDates.findIndex(phase => {
        return (
          isAfter(today, phase.startDate) &&
          (!phase.endDate || isBefore(today, phase.endDate))
        )
      })

      const nextBillingDate = getNextBillingDateForSchedule({
        recurrenceDayOfMonth:
          phaseRecurrenceDates[currentPhaseIndex]?.recurrenceDayOfMonth,
        startDate: phasesWithParsedDates[currentPhaseIndex].startDate,
        endDate: data.billingSchedule.endDate
          ? parse(data.billingSchedule.endDate, 'yyyy-MM-dd', new Date())
          : add(new Date(), { years: 1 }),
        prices: data.prices
      })

      return {
        nextBillingDate
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    nextBillingDate: billingScheduleAggregateQuery.data?.nextBillingDate
  }
}
